import { Injectable, TemplateRef } from '@angular/core';

export interface PanZoomTemplates {
  customContent: TemplateRef<HTMLElement>;
  customMiniatureContent: TemplateRef<HTMLElement>;
  customMiniatureHeader: TemplateRef<HTMLElement>;
  customMiniatureFooter: TemplateRef<HTMLElement>;
}

@Injectable()
export class PanZoomTemplateService {
  public customContent!: TemplateRef<any>;
  public customMiniatureContent!: TemplateRef<any>;
  public customMiniatureHeader!: TemplateRef<any>;
  public customMiniatureFooter!: TemplateRef<any>;
  constructor() {}

  init(templates: PanZoomTemplates) {
    this.customContent = templates.customContent;
    this.customMiniatureContent = templates.customMiniatureContent;
    this.customMiniatureHeader = templates.customMiniatureHeader;
    this.customMiniatureFooter = templates.customMiniatureFooter;
  }
}
